import "./AccessLogSkeleton.scss";

export const AccessLogSkeleton = () => {
  return (
    <div className="access-skeleton-container">
      {/* Search and filters */}
      <div className="access-skeleton-search-row">
        <div className="access-skeleton-search-input pulse"></div>
        <div className="access-skeleton-search-button pulse"></div>
        <div className="access-skeleton-filter-button pulse"></div>
      </div>

      {/* Table header */}
      <div className="access-skeleton-table">
        <div className="access-skeleton-header">
          <div className="access-skeleton-header-cell">
            <div className="access-skeleton-header-content">
              <div className="access-skeleton-header-text pulse"></div>
              <div className="access-skeleton-sort-icon pulse"></div>
              <div className="access-skeleton-info-icon pulse"></div>
            </div>
          </div>

          <div className="access-skeleton-header-cell">
            <div className="access-skeleton-header-content">
              <div className="access-skeleton-header-text pulse"></div>
              <div className="access-skeleton-sort-icon pulse"></div>
              <div className="access-skeleton-info-icon pulse"></div>
            </div>
          </div>

          <div className="access-skeleton-header-cell">
            <div className="access-skeleton-header-content">
              <div className="access-skeleton-header-text pulse"></div>
              <div className="access-skeleton-sort-icon pulse"></div>
              <div className="access-skeleton-info-icon pulse"></div>
            </div>
          </div>

          <div className="access-skeleton-header-cell">
            <div className="access-skeleton-header-content">
              <div className="access-skeleton-header-text pulse"></div>
              <div className="access-skeleton-sort-icon pulse"></div>
              <div className="access-skeleton-info-icon pulse"></div>
            </div>
          </div>

          <div className="access-skeleton-header-cell">
            <div className="access-skeleton-header-content">
              <div className="access-skeleton-header-text pulse"></div>
              <div className="access-skeleton-download-icon pulse"></div>
            </div>
          </div>
        </div>

        {/* Table rows */}
        {Array(8)
          .fill(0)
          .map((_, index) => (
            <div key={index} className="access-skeleton-row">
              <div className="access-skeleton-cell">
                <div className="access-skeleton-date pulse"></div>
              </div>

              <div className="access-skeleton-cell">
                <div className="access-skeleton-user pulse"></div>
              </div>

              <div className="access-skeleton-cell">
                <div className="access-skeleton-type pulse"></div>
              </div>

              <div className="access-skeleton-cell">
                <div className="access-skeleton-action pulse"></div>
              </div>

              <div className="access-skeleton-cell">
                <div className="access-skeleton-details-button pulse"></div>
              </div>
            </div>
          ))}
      </div>

      {/* Pagination info */}
      <div className="access-skeleton-pagination">
        <div className="access-skeleton-pagination-text pulse"></div>
      </div>
    </div>
  );
};
